export const snippet = `<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/mereos@1.1.5/dist/mereos.min.css">
<script src="https://cdn.jsdelivr.net/npm/mereos@1.1.5/dist/mereos.min.js"></script>
`;

export const ASSET_URL = './assets/images'

export const CdnInitFunction = `var credentials = {
client_id: '3425XXXXXXXXXXXXXXXXX',
client_secret: 'HZXXXXXXXXXXXXXXXXXXXXXXXXXX'
}
var candidate_object = {
    type: 'candidate',
    name: 'John Doe',
    email: 'john.doe@gmail.com',
    phone: '+613324234',
    external_id: 'ui11223',
    school: 1999999,
    ...
};

var profile_id = 33212214;

var assessment_object = {
    name: 'Geology',
    external_id: '3235235235' 
    ...
};

var theme_object ={
    language: 'es',
    theming: '#000000',
    mode:'dark'
    ...
};

var resp = window.Mereos.init(credentials, candidate_object, profile_id, assessment_object, theme_object, callback);`

export const NpmInitFunction = `var { init } = require('mereos');

var credentials = {
    client_id: '3425XXXXXXXXXXXXXXXXX',
    client_secret: 'HZXXXXXXXXXXXXXXXXXXXXXXXXXX'
}
var candidate_object = {
    type: 'candidate',
    name: 'John Doe',
    email: 'john.doe@gmail.com',
    phone: '+613324234',
    external_id: 'ui11223',
    school: 1999999,
    ...
}
var profile_id = 33212214;

var assessment_object = {
    name: 'Geology',
    external_id: '3235235235' 
    ...
}
var theme_object = {
    language: 'es',
    theming: '#000000',
    mode:'dark'
    ...
}

var resp = init(credentials, candidate_object, profile_id, assessment_object, theme_object, callback);`

export const startPrecheck = `var resp = window.Mereos.start_prechecks(callback,'session_resume');`

export const npmStartPrecheck = `var { start_prechecks } = require('mereos');
var resp = start_prechecks(callback,'session_resume');`

export const startSessions = `var resp = window.Mereos.start_session(callback);`
export const npmStartSessions = `var { start_session } = require('mereos');
var resp = start_session(callback);`

export const stopSessions = `var resp = window.Mereos.stop_session(callback);`
export const npmStopSessions = `var { stop_session } = require('mereos');
var resp = stop_session(callback);`

export const packageType = {
	npm: `npm install mereos`,
	yarn: `yarn add mereos`,
	pnpm: `pnpm add mereos`
}

export const recordingEntitties = [
	{
		description: "recording_options_desc",
		name: 'recording_options',
		key: 'recording',
		overview: {
			name: 'recording_settings_overview',
			description: 'the_recording_settings_in_mereos_offer'
		},
		entityDescription: [
			{
				heading: 'record_video',
				description: 'record_video_desc'
			},
			{
				heading: 'record_audio',
				description: 'record_audio_desc'
			},
			{
				heading: 'record_screen',
				description: 'record_screen_desc'
			},
			{
				heading: 'record_room',
				description: 'record_room_desc'
			},
			{
				heading: 'mobile_proctoring',
				description: 'mobile_proctoring_desc'
			}
		],
		entities: [
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 2,
				description: "record_video_entity_desc",
				name: 'record_video',
				id: 1,
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/recordVideo.svg',
				key: 'record_video'
			},
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 2,
				description: "track_location_entity_desc",
				name: 'track_location',
				id: 1,
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/trackLocation.svg',
				key: 'track_location'
			},
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 2,
				description: "record_room_entity_desc",
				name: 'record_room',
				image: "https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/360-view.svg",
				id: 2,
				key: 'record_room'
			},
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 2,
				name: 'record_screen',
				description: 'record_screen_entity_desc',
				id: 49,
				key: 'record_screen',
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/recordScreen.svg'
			},
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 2,
				description: 'record_audio_entity_desc',
				image: "https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/recordAudio.svg",
				name: 'record_audio',
				id: 50,
				key: 'record_audio'
			},
			{
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/mobile-phone.svg',
				counter_dependency: [],
				dependency: [],
				entity_group: 2,
				name: 'mobile_proctoring',
				id: 73,
				description: 'mobile_proctoring_entity_desc',
				key: 'mobile_proctoring'
			},
		]
	},
	{
		description: "lockdown_option_desc",
		name: 'lock_down_options',
		key: 'lockdown',
		overview: {
			name: 'lockdown_and_detection_settings_overview',
			description: 'lockdown_and_detection_settings_overview_desc'
		},
		entityDescription: [
			{
				heading: 'force_full_screen',
				description: 'force_full_screen_desc'
			},
			{
				heading: 'disable_printing',
				description: 'disable_printing_desc'
			},
			{
				heading: 'disable_clipboard',
				description: 'disable_clipboard_desc'
			},
			{
				heading: 'disable_right_click',
				description: 'disable_right_click_desc'
			},
			{
				heading: 'detect_unfocus',
				description: 'detect_unfocus_desc'
			},
			{
				heading: 'camera_view',
				description: 'camera_view_desc'
			},
			{
				heading: 'notify',
				description: 'notify_desc'
			},
			{
				heading: 'force_closure',
				description: 'force_closure_desc'
			},
			{
				heading: 'detect_resizing_of_window',
				description: 'detect_resizing_of_window_desc'
			},
			{
				heading: 'disable_keyboard_shortcuts',
				description: 'disable_keyboard_shortcuts_desc'
			},
			{
				heading: 'url_filtering',
				description: 'url_filtering_desc'
			},
			{
				heading: 'disable_highlight_text',
				description: 'disable_highlight_text_desc'
			},
			{
				heading: 'disable_tampering',
				description: 'disable_tampering_desc'
			},
			{
				heading: 'allow_incognito_mode',
				description: 'allow_incognito_mode_desc'
			},
			{
				heading: 'pause_and_resume',
				description: 'pause_and_resume_desc'
			}
		],
		entities: [
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 3,
				description: "force_full_screen_entity_desc",
				name: 'force_full_screen',
				id: 7,
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/forceFullScreen.png',
				key: 'force_full_screen'
			},
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 3,
				description: "disable_right_click_entity_desc",
				name: 'disable_right_click',
				image: "https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/disableRightClick.png",
				id: 10,
				key: 'disable_right_click'
			},
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 3,
				description: "detect_resizing_of_window_entity_desc",
				name: 'detect_resizing_of_window',
				image: "https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/screen-resize.png",
				id: 10,
				key: 'detect_resizing_of_window'
			},
			{
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/disableClipboard.png',
				counter_dependency: [],
				dependency: [],
				entity_group: 2,
				name: 'disable_clipboard',
				id: 73,
				description: 'disable_clipboard_entity_desc',
				key: 'disable_clipboard'
			},
			{
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/disable-printing.svg',
				counter_dependency: [],
				dependency: [],
				entity_group: 2,
				name: 'disable_printing',
				id: 73,
				description: 'disable_printing_entity_desc',
				key: 'disable_printing'
			},
			{
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/camera-view.svg',
				counter_dependency: [],
				dependency: ['record_video'],
				entity_group: 2,
				name: 'camera_view',
				id: 73,
				description: 'camera_view_entity_desc',
				key: 'camera_view'
			},
			{
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/notify.svg',
				counter_dependency: [],
				dependency: [],
				entity_group: 2,
				name: 'notify',
				id: 73,
				description: 'notify_entity_desc',
				key: 'notify'
			},
			{
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/force-closure.svg',
				counter_dependency: [],
				dependency: ['record_video', 'record_screen', 'record_audio'],
				entity_group: 2,
				name: 'force_closure',
				id: 73,
				description: 'force_closure_entity_desc',
				key: 'force_closure'
			},
			{
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/unfocus.png',
				counter_dependency: [],
				dependency: [],
				entity_group: 2,
				name: 'detect_unfocus',
				id: 73,
				description: 'detect_unfocus_entity_desc',
				key: 'detect_unfocus'
			},
			{
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/shortcut-key.svg',
				counter_dependency: [],
				dependency: ['disable_clipboard'],
				entity_group: 2,
				name: 'disable_keyboard_shortcuts',
				id: 73,
				description: 'disable_keyboard_shortcuts_entity_desc',
				key: 'disable_keyboard_shortcuts'
			},
			// {
			// 	image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/urlFiltering.png',
			// 	counter_dependency: [],
			// 	dependency: [],
			// 	entity_group: 3,
			// 	name: 'url_filtering',
			// 	id: 73,
			// 	description: 'url_filtering_entity_desc',
			// 	key: 'url_filtering'
			// },
			{
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/highlight.svg',
				counter_dependency: [],
				dependency: [],
				entity_group: 3,
				name: 'disable_highlight_text',
				id: 403,
				description: 'disable_highlight_text_entity_desc',
				key: 'disable_highlight_text'
			},
			{
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/disable-tampering.svg',
				counter_dependency: [],
				dependency: [],
				entity_group: 3,
				name: 'disable_tampering',
				id: 404,
				description: 'disable_tampering_entity_desc',
				key: 'disable_tampering'
			},
			{
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/incognito-mode.svg',
				counter_dependency: [],
				dependency: [],
				entity_group: 3,
				name: 'allow_incognito_mode',
				id: 405,
				description: 'allow_incognito_mode_entity_desc',
				key: 'allow_incognito_mode'
			},
			{
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/pause-and-resume.svg ',
				counter_dependency: [],
				dependency: [],
				entity_group: 3,
				name: 'pause_and_resume',
				id: 408,
				description: 'pause_and_resume_entity_desc',
				key: 'pause_and_resume'
			},
		]
	},
	{
		description: "verification_options_desc",
		name: 'verification_options',
		key: 'verification',
		overview: {
			name: 'verification_settings_overview',
			description: 'verification_settings_overview_desc'
		},
		entityDescription: [
			{
				heading: 'verify_id',
				description: 'verify_id_desc'
			},
			{
				heading: 'verify_candidate',
				description: 'verify_candidate_desc'
			},
			{
				heading: 'verify_desktop',
				description: 'verify_desktop_desc'
			},
			{
				heading: 'verify_multiple_devices',
				description: 'verify_multiple_devices_desc'
			},
		],
		entities: [
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 4,
				image: "https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/verifyId.svg",
				name: 'verify_id',
				id: 50,
				description: 'verify_id_entity_desc',
				key: 'verify_id'
			},
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 4,
				name: 'verify_candidate',
				description: 'verify_candidate',
				description: 'verify_candidate_entity_desc',
				id: 49,
				key: 'verify_candidate',
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/verify-user.svg'
			},
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 4,
				description: "verify_desktop_entity_desc",
				name: 'verify_desktop',
				id: 64,
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/multipleScreens_AVXMsu2.svg',
				key: 'verify_desktop'
			},
			{
				counter_dependency: ['record_video'],
				dependency: ['record_video'],
				entity_group: 5,
				description: "verify_multiple_devices_entity_desc",
				name: 'verify_multiple_devices',
				id: 402,
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/computers.png',
				key: 'verify_multiple_devices'
			},
		]
	},
	{
		description: "mereos_policy_desc",
		name: 'ai_features',
		key: 'ai',
		overview: {
			name: 'artificial_intelligence_overview',
			description: 'artificial_intelligence_overview_desc'
		},
		entityDescription: [
			{
				heading: 'multiple_people',
				description: 'multiple_people_desc'
			},
			{
				heading: 'person_missing',
				description: 'person_missing_desc'
			},
			{
				heading: 'object_detection',
				description: 'object_detection_desc'
			},
			// {
			//     heading:'speech_detection',
			//     description:'speech_detection_desc'
			// }
		],
		entities: [
			{
				counter_dependency: [],
				dependency: ['record_video', 'camera_view'],
				entity_group: 2,
				description: "multiple_people_entity_desc",
				name: 'multiple_people',
				id: 1,
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/multiple-people-in-the-screen.svg',
				key: 'multiple_people'
			},
			{
				counter_dependency: [],
				dependency: ['record_video', 'camera_view'],
				entity_group: 2,
				description: "person_missing_entity_desc",
				name: 'person_missing',
				image: "https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/no-people-in-the-screen.svg",
				id: 32,
				key: 'person_missing'
			},
			{
				counter_dependency: [],
				dependency: ['record_video', 'camera_view'],
				entity_group: 2,
				name: 'object_detection',
				description: 'object_detection_entity_desc',
				id: 49,
				key: 'object_detection',
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/object-detected.svg'
			},
			// {
			//     counter_dependency:[],
			//     dependency:[],
			//     entity_group: 2,
			//     image: "https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/speech-detected.svg",
			//     name:'speech_detection',
			//     description:'speech_detection_entity_desc',
			//     id:34,
			//     key:'speech_detection'
			// }
		]
	},
	{
		description: "in_quiz_tools_desc",
		name: 'in_quiz_tools',
		key: 'quiz-tools',
		overview: {
			name: 'in_quiz_tools_overview',
			description: 'in_quiz_tools_overview_desc'
		},
		entityDescription: [
			{
				heading: 'chat_bot',
				description: 'chat_bot_desc'
			},
			{
				heading: 'live_chat',
				description: 'live_chat_desc'
			}
		],
		entities: [
			{
				counter_dependency: ['live_chat'],
				dependency: [],
				entity_group: 2,
				description: "chat_bot_entity_desc",
				name: 'chat_bot',
				id: 1,
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/chatbot-icon.svg',
				key: 'chat_bot'
			},
			{
				counter_dependency: ['chat_bot'],
				dependency: [],
				entity_group: 2,
				description: "live_chat_entity_desc",
				name: 'live_chat',
				id: 1,
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/chat-icon.svg',
				key: 'live_chat'
			},
		]
	},
	{
		description: "system_options_desc",
		name: 'system_options',
		key: 'system',
		overview: {
			name: 'system_options_overview',
			description: 'system_options_overview_desc'
		},
		entityDescription: [
			{
				heading: 'verify_ram',
				description: 'verify_ram_desc'
			},
			{
				heading: 'verify_upload_speed',
				description: 'verify_upload_speed_desc'
			},
			{
				heading: 'verify_download_speed',
				description: 'verify_download_speed_desc'
			},
		],
		entities: [
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 36,
				description: "verify_ram_entity_desc",
				name: 'verify_ram',
				id: 394,
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/verify-ram.svg',
				key: 'verify_ram'
			},
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 36,
				description: "verify_upload_speed_entity_desc",
				name: 'verify_upload_speed',
				id: 391,
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/upload-speed.svg',
				key: 'verify_upload_speed'
			},
			{
				counter_dependency: [],
				dependency: [],
				entity_group: 36,
				description: "verify_download_speed_entity_desc",
				name: 'verify_download_speed',
				id: 392,
				image: 'https://d2lxkizvrhu4im.cloudfront.net/proctoring-icons/download-speed.svg',
				key: 'verify_download_speed'
			},
		]
	},
]